import { ProgressBar } from "common/ProgressBar";
import { CircleSpinner } from "common/spinners";
import { Map, Range } from "immutable";
import { loadReportsById } from "lib/api/rideReports";
import fetchJSON from "lib/fetchJSON";
import queryString from "query-string";
import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { ShowcaseCard } from "../Showcase/ShowcaseCard";
import styles from "./VoteAdmin.scss";

export class VoteAdmin extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      totalVotes: null,
      voteCounts: Map(),
      drilldown: null,
      drilldownRecords: Map(),
      minVotes: null,
      maxVotes: null,
    };
  }

  componentDidMount() {
    this.loadAllReports();
    this.grabCounts().then(() => {
      const drilldown = queryString.parse(this.props.location.search).drilldown;
      if (drilldown) {
        this.loadDrilldown(parseInt(drilldown, 10));
      }
    });
  }

  loadAllReports = () => {
    const { finalistIds, loadReportsById } = this.props;

    for (let i = 0; i < Math.ceil(finalistIds.length / 20); i++) {
      const slice = finalistIds.slice(20 * i, 20 * i + 20);
      loadReportsById(slice);
    }
  };

  componentDidUpdate = (prevProps) => {
    const drilldown = queryString.parse(this.props.location.search).drilldown;
    if (drilldown && drilldown !== queryString.parse(prevProps.location.search).drilldown) {
      this.loadDrilldown(parseInt(drilldown, 10));
    }
  };

  grabCounts = () => {
    const { finalistIds } = this.props;
    // grab totalVotes
    fetchJSON("/ride_reports/votes.json?limit=0").then(({ results_count }) =>
      this.setState({ totalVotes: results_count })
    ); // eslint-disable-line

    const finalCounts = finalistIds.map((id) =>
      fetchJSON(`/ride_reports/votes.json?limit=0&ride_report_id=${id}`).then((res) => {
        this.setState({
          voteCounts: this.state.voteCounts.set(id, res.results_count),
        });
        return res.results_count;
      })
    );

    return Promise.all(finalCounts).then((results) => {
      this.setState({
        minVotes: Math.min(...results),
        maxVotes: Math.max(...results),
      });
    });
  };

  loadDrilldown = (id) => {
    this.setState({
      drilldownRecords: this.state.drilldownRecords.set(id, null),
    });
    const pages = Math.ceil(this.state.voteCounts.get(id) / 20);
    const requests = Range(0, pages)
      .map((i) => fetchJSON(`/ride_reports/votes.json?limit=20&offset=${20 * i}&ride_report_id=${id}`))
      .toJS();

    Promise.all(requests).then((responses) => {
      this.setState({
        drilldownRecords: this.state.drilldownRecords.set(
          id,
          responses.map((r) => r.results).reduce((a, b) => a.concat(b))
        ),
      });
    });
  };

  doDrilldown = (reportId) => {
    this.props.history.push({
      pathname: "/ride_reports/vote_admin",
      search: `?drilldown=${reportId}`,
    });
  };

  render() {
    const { finalistIds, reports } = this.props;
    const { votes, voteCounts, totalVotes, minVotes, maxVotes, drilldownRecords } = this.state;
    const drilldown = parseInt(queryString.parse(this.props.location.search).drilldown, 10);

    if (drilldown) {
      const report = reports.get(drilldown);
      const records = drilldownRecords.get(drilldown);

      return (
        <div className={styles.VoteAdmin}>
          <p>
            <Link to="/ride_reports/vote_admin">&laquo; back</Link>
          </p>
          <h1>Vote Drilldown for {report && report.title}</h1>
          {!records && <CircleSpinner size={25} />}
          {records && records.length > 0 && (
            <table className={styles.drilldownTable}>
              <thead>
                <tr>
                  <th>id</th>
                  <th>user</th>
                  <th>account age</th>
                  <th>created_at</th>
                  <th>ip_address</th>
                  <th className={styles.userAgent}>user_agent</th>
                </tr>
              </thead>
              <tbody>
                {records.map((v) => (
                  <tr key={v.id}>
                    <td>{v.id}</td>
                    <td>
                      <a href={`/users/${v.user.id}`} target="_blank">
                        {v.user.name}
                      </a>
                    </td>
                    <td>{v.account_age} days</td>
                    <td>{v.created_at}</td>
                    <td>{v.ip_address}</td>
                    <td className={styles.userAgent}>{v.user_agent}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      );
    }

    if (!voteCounts.size === finalistIds.length) {
      return (
        <div className={styles.VoteAdmin}>
          <h1>Vote Admin</h1>
          <CircleSpinner size={25} />
        </div>
      );
    }

    const byCount = (a, b) => voteCounts.get(b) - voteCounts.get(a);

    return (
      <div className={styles.VoteAdmin}>
        <h1>Vote Admin</h1>
        {totalVotes && <p>Total votes: {totalVotes}</p>}
        {finalistIds
          .filter((id) => reports.has(id))
          .sort(byCount)
          .map((id) => reports.get(id))
          .map((r) => (
            <ReportRow
              report={r}
              drilldown={this.doDrilldown}
              votes={votes}
              voteCounts={voteCounts}
              minVotes={minVotes}
              maxVotes={maxVotes}
              key={r.id}
            />
          ))}
      </div>
    );
  }
}

const ReportRow = ({ report, voteCounts, minVotes, maxVotes, drilldown }) => {
  const voteCount = voteCounts.get(report.id, "?");

  const progress =
    Number.isFinite(minVotes) &&
    Number.isFinite(maxVotes) &&
    Number.isFinite(voteCount) &&
    (voteCount - minVotes) / maxVotes;

  return (
    <div className={styles.reportRow}>
      <div className={styles.reportCard}>
        <ShowcaseCard report={report} />
      </div>
      <div className={styles.stats}>
        <h2>{report.title}</h2>
        <p>{voteCount} votes</p>
        <p>
          <a onClick={() => drilldown(report.id)}>drilldown</a>
        </p>
        {Number.isFinite(progress) && <ProgressBar height="10px" progress={progress} />}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  currentUser: state.currentUser,
  finalistIds: state.rolloutContest.finalistIds,
  reports: state.rideReports.reports,
});

const mapDispatchToProps = {
  loadReportsById,
};

export const VoteAdminContainer = connect(mapStateToProps, mapDispatchToProps)(withRouter(VoteAdmin));
